import axios from 'axios';
import pubSub, { EVENTS } from './pubSub';
import { getTokenFromStorage } from './storageConfig';

function httpClientFactory({ baseUrl, tenantId, token }: { baseUrl: string, tenantId: string, token: string }) {
  const http = axios.create({
    baseURL: baseUrl,
    headers: {
      // Authorization: `Bearer ${tokenToUse}`,
      'X-ID-TENANT-NAME': tenantId
    }
  });


  http.interceptors.request.use((config) => {
    pubSub.publish(EVENTS.PROGRESS, true);
    config.headers['Csrf-Token'] = 'nocheck';
    config.headers['Content-Type'] = 'application/json';
    config.headers.Accept = 'application/json';
    const refreshToken = getTokenFromStorage();
    const tokenToUse = refreshToken ? refreshToken : token;
    config.headers.Authorization = `Bearer ${tokenToUse}`;
    // console.log("pp http request", tokenToUse);
    /* if (!!window.MSInputMethodContext && !!document.DOCUMENT_NODE) {
      config.headers.Pragma = 'no-cache'; // prevent ie11 from caching ajax call results
    } */
    /* get token
    const token = getTokenFromStorage();
    if (token) {
      config.headers['X-Auth-Token'] = token;
    } */
    return config;
  });

  function parseError(messages: any) {
    // error
    if (messages) {
      if (messages instanceof Array) {
        return Promise.reject({ messages });  
      }
      return Promise.reject({ messages: [messages] });  
    }
    return Promise.reject({ messages: ['An error has occured'] });  
  }

  /**
   * parse responsew
   */
  function parseBody(response: any) {
    if (!(response.status >= 400 && response.status <= 599)) {
      return response.data;
    }
    return parseError(response.messages);
  }

  http.interceptors.response.use(
    (response) => {
      // do something with the response data
      console.log('Response was received', response);
      pubSub.publish(EVENTS.PROGRESS, false);
      // !tmp code
      return parseBody(response);
    },
    (error) => {
      // handle the response error
      pubSub.publish(EVENTS.PROGRESS, false); // Moved this line up
      if (!error.response) {
        error.response = {
          status: 599
        }
        pubSub.publish(EVENTS.ERROR, 'common_network_error_msg');
      }
      console.warn('Error status', error.response.status);
      return Promise.reject(error); // This line stays at the end
    }
  );

  return http;
}

export default httpClientFactory;
